export default __webpack_public_path__ + "static/media/32.4d442d65.png";